import { widget } from "@foretagsplatsen/widgetjs";
import companyChartLegendWidget from "../shared/companyChartLegend/companyChartLegendWidget.js";

/**
 * Widget for the legends for the charts on the company page.
 *
 * @param {companyChartWidget} spec.balanceChart - Company chart for the of the period
 * @param {string} [spec.dataHelpName] - String used by the help system to find the legend
 */
function companyLegendWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.openingBalanceLegend = companyChartLegendWidget({
		legendWithDiff: true,
	});

	my.closingBalanceLegend = companyChartLegendWidget({
		legendWithDiff: true,
	});

	my.dataHelpName = spec.dataHelpName || "";

	that.setValues = function (companyTransitionBalance) {
		my.openingBalanceLegend.setCompanyBalance(
			companyTransitionBalance.openingBalance,
		);

		my.closingBalanceLegend.setCompanyBalance(
			companyTransitionBalance.closingBalance,
		);

		my.closingBalanceLegend.setCompanyBalanceChange(
			companyTransitionBalance,
		);
	};

	that.renderContentOn = function (html) {
		html.div(
			{ "data-help": my.dataHelpName, class: "clearfix" },
			html.div(
				{ class: "col-lg-6 col-md-6 col-sm-6 col-xs-6 nopadding" },
				my.openingBalanceLegend,
			),

			html.div(
				{ class: "col-lg-6 col-md-6 col-sm-6 col-xs-6 nopadding" },
				my.closingBalanceLegend,
			),
		);
	};

	return that;
}

export default companyLegendWidget;
